<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <b-img
          fluid
          src="@/assets/images/logo/Udara360-logo.png"
          width="180"
        />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex p-0"
      >
        <div
          v-if="institution.loginPageBackgroundURL"
          class="auth-bg-image"
          role="img"
          aria-label="Institution background"
          :style="{
            backgroundImage: 'url(' + institution.loginPageBackgroundURL + ')',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            width: '100%',
            height: '100%',
          }"
        />
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >

          <Alert
            :show="showFormError"
            :message="errorMessage"
          />

          <!-- form -->
          <validation-observer ref="modifySecurity">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="saveSecurityInfo"
            >
              <b-col md="12">
                <b-card-text class="mb-2">
                  Ensure your answer for the question below is accurate
                </b-card-text>
                <b-card-title class="mb-2">
                  Q. {{ question }}
                <!-- Q. {{ userByUserName.securityQuestion }} -->
                </b-card-title>
              </b-col>
              <!-- answer -->
              <b-col md="12">
                <InputField
                  id="answered-question-1"
                  v-model="Details.answer"
                  label="Enter your answer"
                  placeholder="Enter your answer"
                  type="text"
                  rules="required|max:250"
                  error-name="Security Answer"
                />
              </b-col>

              <!-- submit button -->
              <Button
                class="mt-2"
                label="Next >"
                size="lg"
                block
                :loading="isLoading"
                :disabled="isDisabled"
                @click="saveSecurityInfo"
              />
            <!--/ buttons -->
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{name:'auth-login'}">
              <feather-icon icon="ChevronLeftIcon" /> Back to login
            </b-link>
          </b-card-text>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BCardText, BCardTitle, BImg, BForm,
} from 'bootstrap-vue'
import { required } from '@validations'
import { mapActions, mapGetters } from 'vuex'
import { toastAlert } from '@core/mixins/toast'
import InputField from '../../forms/InputField.vue'
import Button from '../../components/button/Button.vue'
import Alert from '../../components/alert/Alert.vue'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    ValidationObserver,
    InputField,
    Button,
    Alert,
  },
  mixins: [toastAlert],
  data() {
    return {
      Details: {
        answer: '',
      },
      question: '',
      username: '',
      isLoading: false,
      isDisabled: false,
      showFormError: false,
      errorMessage: 'nene',
      status: '',
      required,
    }
  },
  computed: {
    ...mapGetters({
      institution: 'auth/getInstitution',
    }),
  },
  mounted() {
    this.getQuestion()
  },
  methods: {
    ...mapActions({
      saveResetQuestion: 'auth/saveResetQuestion',
    }),
    getQuestion() {
      const { question, username } = this.$route.params
      if (question) {
        this.question = question
        this.username = username
      } else {
        this.$router.push({ name: 'auth-forgot-password' })
      }
    },
    saveSecurityInfo() {
      this.$refs.modifySecurity.validate().then(async success => {
        if (success) {
          try {
            this.showFormError = false
            this.isDisabled = true
            this.isLoading = true
            await this.saveResetQuestion({
              ...this.Details,
              email: this.username,
              question: this.question,
            }).then(() => {
              this.$router
                .push({ name: 'auth-reset-password-v1', params: { user: this.username } })
            })
            this.isDisabled = false
            this.isLoading = false
            return true
          } catch (error) {
            this.showFormError = true
            error.response.data.errors.forEach(responseError => {
              this.errorMessage = responseError.errorMessage
            })
          } finally {
            this.isDisabled = false
            this.isLoading = false
          }
        }
        return false
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
